import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch home banner detail list data
export const getHomeBannerDetailList = createAsyncThunk(
  "homeBannerDetailList/getHomeBannerDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/banner/get_all_data`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        data
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const homeBannerDetailSlice = createSlice({
  name: "homeBannerDetailList",
  initialState: {
    loading: false,
    homeBannerDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHomeBannerDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHomeBannerDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.homeBannerDetailData = action.payload;
      })
      .addCase(getHomeBannerDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default homeBannerDetailSlice.reducer;
